import FieldDetail from './field-detail'
export default [
  {
    path: '/fieldDetail',
    name: 'field-detail',
    component: FieldDetail
  }
]



// WEBPACK FOOTER //
// ./src/components/field-detail/field-detail-router.js